module.exports = __webpack_public_path__ + "static/dronebanner.689ef1e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dronebanner.jpg
// module id = 1494
// module chunks = 256810187883326